import React, { useRef, useEffect, useState, useCallback, useContext } from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import '../layout/sass/_pickListSugestoes.scss'

import '../layout/sass/_responsiveTable.scss'
import api from '../api/api';
import { ToggleButton } from 'primereact/togglebutton';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

export const TabelaPessoaCampanhaMudas = () => {
    const history = useHistory();
    const toast = useRef(null);
    const { user } = useContext(AuthContext);
    const [pessoas, setPessoas] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const confirmationToast = useRef(null)
    const [sortable, setSortable] = useState('ASC');
    const [first, setFirst] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [sortableCampo, setSortableCampo] = useState('id');
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 20,
        sortField: null,
        sortOrder: null,
        filters: {
            'id': { value: "", matchMode: 'contains' },
            'nome': { value: "", matchMode: 'contains' },
            'cpf': { value: "", matchMode: 'contains' },
            'numero_instalacao': { value: "", matchMode: 'contains' },
        }
    });

    const header = (
        <div className="p-grid p-col-12 p-m-0 p-p-0">
            <div>
                <h2 className="p-my-0">Pessoas Campanha Ativa</h2>
            </div>
        </div>

    );

    function desformat(data) {
        return data.replace(/[\D]/g, "");
    }

    function formatCpf(data) {

        const cpf = data.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");

        return cpf;
    }

    const getPessoas = useCallback(async (event) => {
        setIsLoading(true)
        setPessoas([])

        if (event !== undefined) {
            setTimeout(() => {
                const startIndex = event.first;

                setFirst(startIndex);
            }, 250);
        }
        let campanha = await api.get(`campanha/ativoCampanha`);
        try {
            if (lazyParams.filters === undefined) {

                if (event === undefined) {
                    const response = await api.get(`pessoa/campanhaAtiva?sort=${sortableCampo},${sortable}`);

                    response.data.content.forEach(async pessoa => {
                        let entregue = await api.get(`/pessoaMudas/solicitacaoEntregue/${pessoa.id}/${campanha.data.id}`);
                        pessoa.entregue = entregue.data;
                        pessoa.campanhaId = campanha.data.id;
                        setPessoas(pessoas => [...pessoas, pessoa])
                    })
                } else {
                    const response = await api.get(`pessoa/campanhaAtiva?page=${event.page}&sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(async pessoa => {
                        let entregue = await api.get(`/pessoaMudas/solicitacaoEntregue/${pessoa.id}/${campanha.data.id}`);
                        pessoa.entregue = entregue.data;
                        pessoa.campanhaId = campanha.data.id;
                        setPessoas(pessoas => [...pessoas, pessoa])
                    })

                }

                const respElements = await api.get(`pessoa/campanhaAtiva?sort=${sortableCampo},${sortable}`);
                setTotalRecords(respElements.data.totalElements);

            } else {
                const pesquisa = {
                    "id": lazyParams.filters['id'] !== undefined ? lazyParams.filters['id'].value : null,
                    "nome": lazyParams.filters['nome'] !== undefined ? lazyParams.filters['nome'].value : "",
                    "cpf": lazyParams.filters['cpf'] !== undefined ? desformat(lazyParams.filters['cpf'].value) : "",
                    "numero_instalacao": lazyParams.filters['numero_instalacao'] !== undefined ? lazyParams.filters['numero_instalacao'].value : "",
                }

                if (event === undefined) {
                    const respElements = await api.post(`pessoa/searchPessoaCampanhaAtiva/${sortable}/${sortableCampo}?`, pesquisa);
                    respElements.data.content.forEach(async pessoa => {
                        let entregue = await api.get(`/pessoaMudas/solicitacaoEntregue/${pessoa.id}/${campanha.data.id}`);
                        pessoa.entregue = entregue.data;
                        pessoa.campanhaId = campanha.data.id;
                        setPessoas(pessoas => [...pessoas, pessoa])
                    })
                    setTotalRecords(respElements.data.totalElements);
                } else {
                    const respElements = await api.post(`pessoa/searchPessoaCampanhaAtiva/${sortable}/${sortableCampo}?page=${event.page}`, pesquisa);
                    respElements.data.content.forEach(async pessoa => {
                        let entregue = await api.get(`/pessoaMudas/solicitacaoEntregue/${pessoa.id}/${campanha.data.id}`);
                        pessoa.entregue = entregue.data;
                        pessoa.campanhaId = campanha.data.id;
                        setPessoas(pessoas => [...pessoas, pessoa])
                    })
                    setTotalRecords(respElements.data.totalElements);
                }

            }

        }
        catch (error) {
            if (lazyParams !== undefined) {
                if (event === undefined) {
                    const response = await api.get(`pessoa/campanhaAtiva?sort=nome,${sortable}`);
                    response.data.content.forEach(async pessoa => {
                        let entregue = await api.get(`/pessoaMudas/solicitacaoEntregue/${pessoa.id}/${campanha.data.id}`);
                        pessoa.entregue = entregue.data;
                        pessoa.campanhaId = campanha.data.id;
                        setPessoas(pessoas => [...pessoas, pessoa])
                    })
                } else {
                    const response = await api.get(`pessoa/campanhaAtiva?page=${event.page}&sort=nome,${sortable}`);
                    response.data.content.forEach(async pessoa => {
                        let entregue = await api.get(`/pessoaMudas/solicitacaoEntregue/${pessoa.id}/${campanha.data.id}`);
                        pessoa.entregue = entregue.data;
                        pessoa.campanhaId = campanha.data.id;
                        setPessoas(pessoas => [...pessoas, pessoa])
                    })

                }

                const respElements = await api.get(`pessoa/campanhaAtiva?sort=id,${sortable}`);
                setTotalRecords(respElements.data.totalElements);
            } else {
                toast.current.show({ severity: 'error', summary: 'Erro ao obter pessoas', detail: error.toString() });
            }
        }

        setIsLoading(false)
    }, [lazyParams, sortable, sortableCampo]);

    useEffect(() => {
        const fetchpessoas = async () => {
            try {
                await getPessoas();

            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
            }
        }
        fetchpessoas();

    }, [getPessoas])

    const idBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.id}</span>
                </p>
            </React.Fragment>
        );
    }

    const nomeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Nome</span>
                    <span className="table-data">{rowData.nome.toUpperCase()}</span>
                </p>
            </React.Fragment>
        );
    }

    const cpfBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">CPF</span>
                    <span className="table-data">{rowData.cpf ? formatCpf(rowData.cpf) : rowData.cpf}</span>
                </p>
            </React.Fragment>
        );
    }

    const numeroInstalacaoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Nº Instalação</span>
                    <span className="table-data">{rowData.numero_instalacao}</span>
                </p>
            </React.Fragment>
        );
    }

    const handleEntregueChange = async (pessoaId, campanhaId, entregue) => {
        let pessoaMudas = await api.get(`/pessoaMudas/solicitacao/${pessoaId}/${campanhaId}`);
        let tempPessoaId = pessoaMudas.data[0].pessoaId;
        pessoaMudas.data.forEach(async pessoaMuda => {
            let tempPessoaMuda = {
                "id": pessoaMuda.id,
                "quantidade": pessoaMuda.quantidade,
                "pessoaId": pessoaMuda.pessoaId,
                "campanhaMudaId": pessoaMuda.campanhaMudaId,
                "campanhaId": pessoaMuda.campanhaId,
                "mudaEntregue": !entregue,
            }
            await api.put("pessoaMudas", tempPessoaMuda)
        });

        const tempPessoas = pessoas.map(pessoa => {
            if (pessoa.id === tempPessoaId) {
                return { ...pessoa, entregue: !entregue };
            }
            return pessoa;
        });

        setPessoas(tempPessoas)
    }

    const entregueBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <ToggleButton
                    checked={rowData.entregue}
                    onChange={() => handleEntregueChange(rowData.id, rowData.campanhaId, rowData.entregue)}
                    onLabel="SIM" offLabel="NÃO"
                    onIcon="pi pi-check" offIcon="pi pi-times" aria-label="Confirmation" />
            </div>
        );
    }

    const onSort = (event) => {
        setSortableCampo(event.sortField);
        if (sortable === 'ASC') {
            setSortable('DESC')
        } else if (sortable === 'DESC') {
            setSortable('ASC')
        }
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    return (
        <>
            <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">

                <Toast ref={toast} position="bottom-right" />

                <Toast ref={confirmationToast} position="bottom-center" />

                <div className="card p-col-12 datatable-responsive-demo">

                    <div className="p-fluid">
                        <DataTable
                            totalRecords={totalRecords}
                            lazy="true"
                            first={first}
                            onPage={getPessoas}
                            header={header}
                            value={pessoas}
                            filterDisplay="row"
                            className="p-datatable-responsive-demo"
                            emptyMessage="Nenhuma pessoa encontrada"
                            loading={isLoading}
                            dataKey="id"
                            paginator
                            rows={20}
                            currentPageReportTemplate={`Mostrando de {first} a {last} de ${totalRecords} pessoas`}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                            rowsPerPageOptions={[20, 100]}
                            onSort={onSort}
                            onFilter={onFilter}
                            filters={lazyParams.filters}
                        >

                            <Column
                                field="id"
                                header="Código"
                                sortable
                                body={idBodyTemplate}
                                lazyParams
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar por Código"

                            />

                            <Column
                                field="nome"
                                header="Nome"
                                sortable
                                body={nomeBodyTemplate}
                                lazyParams
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar por Nome"

                            />

                            <Column
                                field="cpf"
                                header="CPF"
                                sortable
                                body={cpfBodyTemplate}
                                lazyParams
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar por CPF"

                            />

                            <Column
                                field="numero_instalacao"
                                header="Nº da Instalação"
                                sortable
                                body={numeroInstalacaoBodyTemplate}
                                lazyParams
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar pelo Nº da instalação"

                            />

                            <Column
                                header="Mudas Entregues"
                                body={entregueBodyTemplate}

                            />

                        </DataTable>

                    </div>
                </div>
            </div>

        </>
    );
}
